import { session } from '@/utils/storage';
const { isCore } = JSON.parse(session.get('user-infor') || '{}');
export const routeConfig = {
  meta: {
    title: isCore ? '分析视图' : '数据统计',
  },
  redirect: '/dataStatistics/financing'
};
